(function () {
    'use strict';

    angular
        .module('adminCACMControllers', ['cacmModule', 'services.authenticatedUser']);
})();
